/* eslint-disable */
import { Link } from "react-router-dom";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { assetImages } from "constants";

import * as url from "helper/UrlHelper";

import { getData } from "utils/Gateway";
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import { createTaskChatHandler } from "helper/TaskHelper/TaskHelper";

import TaskPriority from "data/Prod/TaskPriority.json";
import TaskStatus from "data/Prod/TaskStatus.json";

const ColumnItem = (props) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { id, item, setReloadData, setSelectedComponentId, setSelectedTagId } =
    props;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: 2,
    margin: 2,
    background: "#fff",
    //border: "1px solid #ccc"
  };

  // delete item
  const deleteComponentOrder = async (id) => {
    console.log("Delete Item: ", id);

    if (!window.confirm("Are you sure you want to delete this item?")) {
      return;
    }

    // set json data for each column ---------------------
    const columnItemsURL =
      url.API_BASE_URL +
      url.API_DELETE_COMPONENTORDER +
      `/${id}`;

    console.log("columnItemsURL", columnItemsURL);

    const response = await getData(columnItemsURL);

    console.log("deleteComponentOrderResponse", response);

    if (response.status) {
      setReloadData(true);
    }
  };

  const viewItemDetails = (itemid) => {
    // console.log("viewItemDetails for id", itemid);

    setSelectedComponentId(itemid);
    setSelectedTagId(null);
  };

  return (
    // Details about the lead - single card item
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div className="single-card p-3 border border-gray-300 rounded-10 mb-2">
        <div className="get-code-row d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
            <p
              className="fs-md fw-semibold mb-0 d-flex"
              title="Referenece id"
              onPointerDown={(e) => {
                e.stopPropagation();
                viewItemDetails(item.task._id);
              }}
            >
              {item.task?.customid ?? ""}
            </p>
            <Link
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#addTask_view"
              aria-controls="addTask_view"
              onPointerDown={(e) => {
                e.stopPropagation();
                viewItemDetails(item.task._id);
              }}
            >
              <span className="d-block material-symbols-outlined icon-md">
                edit
              </span>
            </Link>
          </div>

          <div className="menu_info">
            <button
              className="p-0 bg-transparent border-0 ms-2"
              type="button"
              onPointerDown={(e) => {
                e.stopPropagation();
                deleteComponentOrder(item.id);
              }}
            >
              <span className="d-block material-symbols-outlined icon-md text-danger">
                delete
              </span>
            </button>
          </div>
        </div>

        <div className="card-user-info d-flex align-items-center gap-2 mb-2">
          <h4 className="mb-0 text-black">{item.task.title}</h4>
        </div>

        <p className="fs-sm text-gray d-flex align-items-center gap-1 mb-3">
          <span className="d-block material-symbols-outlined icon-sm">
            calendar_month
          </span>
          <span className="d-block">
            {getCurrentDateInString(item.task.start, "dd/mm/yyyy")}
          </span>
          <span className="d-block ms-2">
            {getCurrentDateInString(item.task.end, "dd/mm/yyyy")}
          </span>
          <span className="ms-1 d-inline-block fs-xs lh-1 text-white px-2 py-1 bg-primary rounded-90">
            {TaskPriority.map((priority, index) => {
              if (item.task.priority === priority.value) {
                return priority.label;
              }
            })}
          </span>
        </p>

        <div className="d-flex align-items-center gap-3 mb-3">
          <div className="profile d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{
                width: "22px",
                height: "22px",
              }}
            >
              <img
                src={
                  item.task.assigneduserimage === ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + item.task.assigneduserimage
                }
                alt="User"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <p className="fs-sm">{item.task.assignedusername}</p>
            <button
              className={
                !item.task.assigneduser ||
                item.task.assigneduser === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
              onClick={() => {
                createTaskChatHandler(item.task._id);
              }}
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
          <p className="d-flex align-items-center gap-1">
            <span className="d-block material-symbols-outlined icon-sm">
              schedule
            </span>
            <span className="d-block fs-sm">{item.task.hours} Hr</span>
          </p>
        </div>

        <div className="d-flex align-items-center gap-2">
          <p className="d-flex align-items-center gap-1">
            <span className="d-block material-symbols-outlined icon-sm">
              stars
            </span>
            <span>Rank : </span>
            <span className="d-block fs-sm">{item.task.rank}</span>
          </p>
          <span className="d-inline-block fs-xs lh-1 text-white px-2 py-1 bg-primary rounded-90">
            {TaskStatus.map((status, index) => {
              if (item.task.completedpercent === status.value) {
                return status.label;
              }
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ColumnItem;
